import { getPageDescriptor, getPageContent } from '@pm2/api';
import { pageParsers } from '@pm2/content-engine';
import { getRevisionByIdRequest } from '@pm2/course-revisions';
import { xml2ast, findInAST } from '@utils/ast';

async function getFavouriteDataRequest(config, descriptor) {
  if (descriptor.version !== "1") {
    throw new Error(`getFavouriteData(): Invalid version received, only '1' is currently supported. Received: '${descriptor.version}'`);
  }
  switch (descriptor.type) {
    case "page":
      {
        const data = await getPageDescriptor(config.config, descriptor.pageId, {
          previewMode: config.previewMode
        });
        if (!data) {
          return null;
        }
        const vignette = await (async () => {
          if (data.vignette) {
            return data.vignette;
          }
          const content = xml2ast(await getPageContent(config.config.id, descriptor.pageId, {
            previewMode: config.previewMode
          }), pageParsers);
          const node = findInAST(content, node => node.nodeType === "image-component" || node.nodeType === "split-component");
          switch (node?.nodeType) {
            case "image-component":
              return {
                url: node.imageSrc,
                width: node.meta.imageWidth,
                height: node.meta.imageHeight,
                alt: node.meta.alt
              };
            case "split-component":
              return {
                url: node.image.imageSrc,
                width: node.image.meta.imageWidth,
                height: node.image.meta.imageHeight,
                alt: node.image.meta.alt
              };
          }
        })();
        return {
          ...descriptor,
          path: data.path,
          title: data.title,
          vignette
        };
      }
    case "course":
      {
        const data = await getPageDescriptor(config.config, descriptor.courseId, {
          previewMode: config.previewMode
        });
        if (!data) {
          return null;
        }
        try {
          const revision = descriptor.revisionId ? await getRevisionByIdRequest(descriptor.revisionId) : undefined;
          const path = `${data.path}?revisionId=${revision?.id ?? data.id}&revisionTitle=${revision?.name ?? ""}`;
          return {
            ...descriptor,
            path,
            title: data.title,
            vignette: data.vignette,
            revisionId: revision?.id,
            revisionTitle: revision?.name
          };
        } catch (err) {
          console.error(err);
          return {
            ...descriptor,
            path: data.path,
            title: data.title,
            vignette: data.vignette
          };
        }
      }
  }
}

export { getFavouriteDataRequest };
//# sourceMappingURL=get-data.request.js.map
